import { getTheme } from "@clipboard-health/ui-theme";
import { isDefined } from "@clipboard-health/util-ts";
import { ThemeProvider } from "@mui/material";
import { PageWrapper } from "@src/appV2/redesign/components/PageWrapper";

import { useInHomeVisitModalsDataContext } from "../../ShiftDiscovery/useInHomeVisitModalsDataContext";
import { BookedVisitDetailsContent } from "./Content";
import { BookedVisitDetailsFooter } from "./Footer";
import { BookedVisitDetailsHeaderWrapper } from "./HeaderWrapper";

export function BookedVisitDetailsPage() {
  const { visit, isVisitLoading, isVisitError } = useInHomeVisitModalsDataContext();

  const isPageDataSuccess = !isVisitLoading && !isVisitError;

  return (
    <ThemeProvider theme={getTheme()}>
      <PageWrapper variant="tertiary">
        {isDefined(visit) && (
          <BookedVisitDetailsHeaderWrapper isPageDataSuccess={isPageDataSuccess} />
        )}

        <BookedVisitDetailsContent />

        {!isVisitLoading && isDefined(visit) && <BookedVisitDetailsFooter />}
      </PageWrapper>
    </ThemeProvider>
  );
}
